import type { EffectiveServiceOffering } from "@/lib/service/types";
import { shouldShowServiceClosedCallout } from "@/lib/opportunity/serviceOpportunityMatch";
import type { Opportunity } from "@/types/opportunity";

export function OpportunityServiceClosedCallout(props: {
  opportunity: Opportunity;
  matchedOffering: EffectiveServiceOffering | null;
  onOpenDocuments: () => void;
}) {
  const { opportunity, matchedOffering, onOpenDocuments } = props;
  if (!shouldShowServiceClosedCallout(opportunity.status, matchedOffering)) return null;

  return (
    <div
      className="rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-950 dark:border-emerald-900 dark:bg-emerald-950/35 dark:text-emerald-100"
      data-testid="service-closed-callout"
    >
      <p className="font-medium">Service order recorded</p>
      <p className="mt-1 text-emerald-900/90 dark:text-emerald-100/90">
        Scheduling handoff is on the publisher&apos;s Service queue when applicable. The commercial
        record for this sale stays on this Opportunity (revision + generated proposal PDF). Ops deal
        paperwork is optional — upload any additional signed documents manually.
      </p>
      <button
        type="button"
        onClick={onOpenDocuments}
        className="mt-2 text-sm font-semibold text-emerald-800 underline underline-offset-2 hover:text-emerald-950 dark:text-emerald-300 dark:hover:text-emerald-100"
      >
        Attach signed service documents →
      </button>
      {matchedOffering?.is_inherited ? (
        <p className="mt-2 text-xs text-emerald-800/80 dark:text-emerald-200/80">
          Inherited service from {matchedOffering.publisher_org_name}. Use the Documents tab slots
          configured for this product type; proposal PDFs live under Generated.
        </p>
      ) : null}
    </div>
  );
}
